
import React from 'react';
import { Helmet } from 'react-helmet-async';
import HomeStructuredData from './HomeStructuredData';
import SEOMetadata from '../common/SEOMetadata';

interface HomeSEOProps {
  title?: string;
  description?: string;
}

const HomeSEO: React.FC<HomeSEOProps> = ({ 
  title = "Cats About Town Tours | New York Feline History Walking Tours",
  description = "Explore New York's feline history with Cats About Town Tours. Join our unique walking tours to discover the cats that shaped NYC. Book your $40 tour today!"
}) => {
  return (
    <>
      <SEOMetadata
        title="Cats About Town Tours | New York Feline History Walking Tours"
        description="Explore New York's feline history with Cats About Town Tours. Join our unique walking tours to discover the cats that shaped NYC. Book your $40 tour today!"
        canonicalUrl="https://catsabouttowntours.com/"
        ogImage="/lovable-uploads/f0cb5bcd-d58d-44ab-9619-011f839bec4f.png"
        ogType="website"
        keywords={[
          "NYC cat history tours", 
          "feline walking tours NYC", 
          "cat history New York", 
          "Brooklyn Heights cat tour", 
          "Lower East Side cat history", 
          "Financial District cat walking tour",
          "Peggy Gavan tour guide",
          "historical NYC cats"
        ]}
      />
      
      <Helmet>
        {/* Additional Home-specific meta tags */}
        <meta name="geo.region" content="US-NY" />
        <meta name="geo.placename" content="New York City" />
        
        {/* Mobile Meta Tags */}
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
        <meta name="theme-color" content="#8B4513" />
        
        {/* Preload Critical Resources */}
        <link rel="preload" as="image" href="/lovable-uploads/f0cb5bcd-d58d-44ab-9619-011f839bec4f.png" />
        <link rel="preload" as="image" href="/lovable-uploads/e100a577-5b2e-45e7-8c5a-045a615b98ba.png" />
        <link rel="preload" as="image" href="/lovable-uploads/cf69d03b-6e71-43d3-936d-5465eaa5212f.png" />
        
        {/* DNS Prefetch */}
        <link rel="dns-prefetch" href="https://fareharbor.com" />
      </Helmet>
      
      {/* Structured Data is now a separate component that will render its own script */}
      <HomeStructuredData />
    </>
  );
};

export default HomeSEO;
